export default __webpack_public_path__ + "static/media/Learnsuite.19cb10e1.png";